<script lang="ts">
	import { fly } from 'svelte/transition';
	import type { Alert } from './alert.type';
	import { clearAlertTimeout } from './alert.store';
	import DOMPurify from 'dompurify';

	export let alert: Alert;
	export let isVisible = true;

	// Sanitize the HTML content
	let sanitizedHTML = DOMPurify.sanitize(alert.text);
</script>

{#if isVisible && sanitizedHTML}
	<aside
		class="alert z-50 top-16 fixed"
		class:alert--success={alert.type === 'success'}
		class:alert--error={alert.type === 'error'}
		transition:fly={{ y: 100 }}
	>
		<div class="alert__content">
			{#if alert.type === 'success'}
				<svg
					class="w-6 h-6 inline-block"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
					/>
				</svg>
			{:else}
				<svg
					class="w-6 h-6 inline-block"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
					/>
				</svg>
			{/if}
			<p class="m-5">
				<!-- eslint-disable-next-line svelte/no-at-html-tags -->
				{@html sanitizedHTML}
				<!-- {@html alert.text} -->
			</p>
			<button
				class="alert__action-close"
				on:click={() => (isVisible = !isVisible)}
				on:click={() => clearTimeout(clearAlertTimeout())}
			>
				<svg
					class="w-6 h-6 inline-block"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			</button>
		</div>
	</aside>
{/if}

<style lang="postcss">
	.alert {
		@apply block shadow-md rounded px-3 py-2 transition-all bg-bloomYellow text-gray-800 border-2 border-bloomOrangeNormal mt-10;
	}
	.alert__content {
		@apply flex gap-2 font-bold;
	}
	.alert__content p {
		@apply max-w-xs break-words text-base;
	}
	.alert--success {
		@apply bg-green-300 text-gray-800  border-green-500;
	}
	.alert--error {
		@apply bg-red-500 text-white;
	}
	.alert__action-close {
		@apply inline-grid place-content-center rounded-full w-5 h-5 border-0 m-0 p-0 transition-colors;
	}
	.alert__action-close:hover {
		@apply text-gray-200 bg-gray-500;
	}
	.alert--success .alert__action-close {
		@apply text-gray-400 bg-green-200;
	}
	.alert--success .alert__action-close:hover {
		@apply bg-green-700 text-white;
	}
	.alert--error .alert__action-close {
		@apply text-gray-300 bg-red-600;
	}
	.alert--error .alert__action-close:hover {
		@apply text-red-600 bg-red-300;
	}
</style>
